export const menuItems = [
  {
    id: 1,
    text: "Home",
    url: "/",
    isActive: true,
  },
  {
    id: 2,
    text: "Courses",
    url: "/courses",
  },
  {
    id: 3,
    text: "Admin Space",
    url: "/adminSpace",
    roles: ["Admin"],
  },
  {
    id: 4,
    text: "Division Manager Space",
    url: "/Departments",
    roles: ["DivisionManager"],
  },
  {
    id: 5,
    text: "Project Manager Space",
    url: "/projectManagerSpace",
    roles: ["Project Manager"],
  },
  {
    id: 6,
    text: "Center Manager Space",
    url: "/trainingmanager",
    roles: ["Editor"],
  },
  // {
  //   id: 7,
  //   text: "About Us",
  //   url: "/",
  // },
  {
    id: 8,
    text: "Contact",
    url: "/contact-us",
  },
];
